import styled from '@emotion/styled'
import { concat, includes, without } from 'lodash'
import { breakpoints, Checkbox, Hidden, spacing, Strong, Text, Visible } from 'main/ui'
import { stars } from 'main/util/networkRating'
import { IFilters } from 'main/util/search'
import * as React from 'react'

import {
  Apply,
  CheckboxGroupContainer,
  Clear,
  FieldCopyContainer,
  FieldsContainer,
  FilterFormContainer as CommonFilterFormContainer,
  FilterFormSubmitContainer,
} from '../../common/FilterForm.styles'
import { ISearchFormProps } from '../../types'

import { LinkWithLeftPaddingSometimes, SpaceBetweenFlexSpan } from './FilterForm.styles'

const FilterFormContainer = styled(CommonFilterFormContainer)`
  @media (min-width: ${breakpoints.lg}px) {
    padding: ${spacing.majorScale(3)}px ${spacing.majorScale(4)}px ${spacing.majorScale(4)}px;
    max-width: 310px;
  }
`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props

  const [params, setParams] = React.useState<IFilters>({ ...filters })

  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({ ...filters, selectedNetworkRatings: params.selectedNetworkRatings })
  }
  function handleClear() {
    setParams({ ...params, selectedNetworkRatings: [] })
  }

  return (
    <FilterFormContainer>
      <Fields params={params} onChangeParams={setParams} />
      <Visible lg xl>
        <FilterFormSubmitContainer css={{ marginTop: spacing.minorScale(5) }}>
          <Clear data-pendo="selectedProgramTypesFilter-clear" onClick={() => handleClear()}>
            Clear
          </Clear>
          <Apply data-pendo="selectedProgramTypesFilter-apply" onClick={() => handleApply()}>
            Apply
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )
}

export function Fields(fieldsProps: {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}) {
  const { params, onChangeParams } = fieldsProps
  const formOptions = [
    { label: 'Level 4', value: 4 },
    { label: 'Level 3', value: 3 },
    { label: 'Level 2', value: 2 },
    { label: 'Level 1', value: 1 },
    { label: 'No Level', value: -1 },
  ]

  const eliLearnMoreLink = 'https://pages.wonderschool.com/early-learning-marketplace-pte'

  return (
    <div>
      <Visible lg xl>
        <SpaceBetweenFlexSpan>
          <Strong>{'Paths to QUALITY\u2122 Level'}</Strong>
          <LinkWithLeftPaddingSometimes href={eliLearnMoreLink} target="_blank">
            Learn more
          </LinkWithLeftPaddingSometimes>
        </SpaceBetweenFlexSpan>
      </Visible>
      <Hidden lg xl>
        <FieldCopyContainer>
          <Text>
            <Strong>{'Paths to QUALITY\u2122 Level'}</Strong>
            <div>
              <LinkWithLeftPaddingSometimes href={eliLearnMoreLink} target="_blank">
                Learn more
              </LinkWithLeftPaddingSometimes>
            </div>
          </Text>
        </FieldCopyContainer>
      </Hidden>
      <FieldsContainer>
        <CheckboxGroupContainer css={{ width: 'max-content' }}>
          {formOptions.map(option => {
            const label = `${option.label}`
            return (
              <Checkbox
                key={option.label}
                checked={includes(params.selectedNetworkRatings, option.value)}
                label={
                  <div>
                    {label} {stars(option.value)}
                  </div>
                }
                onChange={(checked: boolean) => {
                  checked
                    ? onChangeParams({
                        ...params,
                        selectedNetworkRatings: concat(params.selectedNetworkRatings, option.value),
                      })
                    : onChangeParams({
                        ...params,
                        selectedNetworkRatings: without(
                          params.selectedNetworkRatings,
                          option.value,
                        ),
                      })
                }}
              />
            )
          })}
        </CheckboxGroupContainer>
      </FieldsContainer>
    </div>
  )
}
